import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")

  return (_openBlock(), _createBlock(_component_Breadcrumb, {
    class: "workspace-breadcrumbs",
    home: _ctx.home,
    model: _ctx.items
  }, {
    item: _withCtx(({item}) => [
      _createVNode("span", {
        class: "workspace-breadcrumbs-item",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.selectBreadcrumb && _ctx.selectBreadcrumb(...args)))
      }, _toDisplayString(item.label), 1)
    ]),
    _: 1
  }, 8, ["home", "model"]))
}